import * as React from 'react';
import {useState} from 'react';
import {Button} from "antd";
import { CoverLetter } from './Modals/CoverLetter';

type ReplyButtonProps = {
    style: object, 
    vacancyId: number, 
    reaction?: boolean,
}

export const ReplyButton = ({style, vacancyId, reaction = false} : ReplyButtonProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isReaction, setIsReaction] = useState(reaction)

    const showModal = async () => {
        if (!isReaction) {
            setIsModalOpen(true);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return(
        <>
            {(isReaction) ? 
                <button className="green-button" style={style}> Смотреть отклик </button> :
                <Button type="primary" onClick={showModal} style={style}>Откликнуться</Button>
            }
            <CoverLetter isOpen={isModalOpen} close={closeModal} vacancyId={vacancyId} setReaction={setIsReaction}/>
        </>
    )
}